import { Message, defineMessage } from 'magpie-lib/models';
import { CSSProperties } from 'react';
import * as t from 'ts-schema';
import { ValueOf } from '../types';

// NOTE: Messasges in this file are intended for use with `magpie-lib`

const commons = {
  platformName: t.string,
};

const setIsOpen = defineMessage({
  type: 'set-is-open' as const,
  payloadSchema: t.object({
    name: t.string,
    value: t.boolean,
    ...commons,
  }),
});

export const getStateReply = defineMessage({
  type: 'get-state-reply' as const,
  payloadSchema: t.object({
    isLoaded: t.boolean,
    isOpen: t.boolean,
    isReady: t.boolean,
    isDisabled: t.boolean,
    isFullscreenMode: t.boolean,
    style: t.custom(
      'CSSProperties',
      (value: unknown): value is CSSProperties => typeof value === 'object'
    ),
  }),
});

const getState = defineMessage({
  type: 'get-state' as const,
  payloadSchema: t.object({
    name: t.string,
    ...commons,
  }),
  reply: getStateReply,
});

const getPropsReply = defineMessage({
  type: 'get-props-reply' as const,
  payloadSchema: t.object({}),
});

const getProps = defineMessage({
  type: 'get-props' as const,
  payloadSchema: t.object({
    name: t.string,
    ...commons,
  }),
  reply: getPropsReply,
});

const setProps = defineMessage({
  type: 'set-props' as const,
  payloadSchema: t.object({
    name: t.string,
    value: t.record(t.string, t.any),
    ...commons,
  }),
});

export const setIsLoadedReply = defineMessage({
  type: 'set-is-loaded-reply' as const,
});

const setIsLoaded = defineMessage({
  type: 'load-component' as const,
  payloadSchema: t.object({
    name: t.string,
    value: t.boolean,
    ...commons,
  }),
  reply: setIsLoadedReply,
});

const invokeFunctionReply = defineMessage({
  type: 'invoke-function-reply' as const,
});

const invokeFunction = defineMessage({
  type: 'invoke-function' as const,
  payloadSchema: t.object({
    name: t.string,
    fnName: t.string,
    args: t.any,
    ...commons,
  }),
  reply: invokeFunctionReply,
});

export const ncRemoteOperations = {
  setIsOpen,
  getState,
  setProps,
  setIsLoaded,
  getProps,
  invokeFunction,
} as const;

export const ncRemoteOperationsReplies = {
  getStateReply,
  getPropsReply,
  setIsLoadedReply,
  invokeFunctionReply,
} as const;

export type AnyNavRemoteOperationMessage = Message<
  ValueOf<typeof ncRemoteOperations>['spec']
>;
